<dx-select-box
  valueExpr="EmployeeId"
  displayExpr="EmployeeNumberAndName"
  searchExpr="EmployeeNumberAndName"
  searchEnabled="true"
  showClearButton="true"
  [dataSource]="employees"
  [value]="selectedEmployee"
  [placeholder]="languageService.LNG('Label.Employee')"
  (onValueChanged)="onEmployeeValueChanged($event)">
</dx-select-box>
